export default "__VITE_ASSET__BfGtuxqp__"